import Config from "../config";

/**
 * Builds the redirect url for payrexx payment page
 * @param {*} [location] to test the function a Location object can be passed. In production it takes the value from window.location.href
 */
function getRedirectUrl(location, routerBasename) {
  location = location || window.location;
  routerBasename = routerBasename || Config.routerBasename || "";
  
  const parts = [];
  parts.push(`${location.protocol}//${location.host}`);
  if(routerBasename.length > 0) {
    parts.push(routerBasename);
  }
  parts.push("checkout");
  parts.push("finalizepayment");

  const baseUrl = parts.join("/");

  return baseUrl;
}

export default {
  getRedirectUrl
}